import React, { Component } from 'react'
import CollapsibleFilterGroup from '@components/CollapsibleFilterGroup'
import { observer, inject } from 'mobx-react'
import propTypes from 'prop-types'

import FilterGroup from '@components/FilterGroup'
import { SearchPanelContainer } from '@components/Search'
import { Dropdown, Autocomplete } from '@components/Autocomplete'
import { DatePickerRange } from '@components/DatePicker'

const feeTypeStrings = {
  ALL: 'All',
  BUNDLE: 'Bundle',
  CLIENT_CHARGE: 'Client charge',
  COST: 'Cost'
}

class GeneralFeesSearchPanel extends Component {
  static propTypes = {
    generalFeesStore: propTypes.object
  }

  onClearSearch = () => {
    this.props.generalFeesStore.clear()
  }

  render () {
    const store = this.props.generalFeesStore
    return (
      <SearchPanelContainer
        searchTitle='General Fees'
        onClearSearch={this.onClearSearch}
      >
        <FilterGroup label='Client Account'>
          <Autocomplete
            itemFromCreatable={item => ({ label: item, value: item })}
            itemToString={item => item && item.label}
            placeholder='Select client account'
            loadOptions={store.autocompleteClientAccounts}
            onChange={val => store.setVal('account', val)}
            value={store.model.account}
          />
        </FilterGroup>
        <FilterGroup label='Project'>
          <Autocomplete
            itemFromCreatable={item => ({ label: item, value: item })}
            itemToString={item => item && item.label}
            placeholder='Select project'
            loadOptions={store.autocompleteProjects}
            onChange={val => store.setVal('project', val)}
            value={store.model.project}
          />
        </FilterGroup>
        <FilterGroup label='Contract'>
          <Autocomplete
            itemFromCreatable={item => ({ label: item, value: item })}
            disabled={store.model.noContract}
            itemToString={item => item && item.label}
            placeholder='Select contract'
            loadOptions={store.autocompleteContracts}
            onChange={val => store.setVal('contract', val)}
            value={store.model.contract}
          />
        </FilterGroup>
        <FilterGroup>
          <label className='checkbox'>
            <input
              type='checkbox'
              value
              checked={store.model.noContract}
              onChange={e => store.setVal('noContract', e.target.checked)}
            />
            Without a contract
          </label>
        </FilterGroup>
        <CollapsibleFilterGroup title='Date range' open>
          <FilterGroup>
            <DatePickerRange
              dateOnly
              onFromChange={val => store.setVal('startDate', val)}
              onToChange={val => store.setVal('endDate', val)}
              fromDate={store.model.startDate}
              toDate={store.model.endDate}
            />
          </FilterGroup>
        </CollapsibleFilterGroup>
        <CollapsibleFilterGroup title='Type' open>
          <FilterGroup>
            <Dropdown
              selectedItem={store.model.feeType}
              placeholder='Select type'
              options={['ALL', 'BUNDLE', 'CLIENT_CHARGE', 'COST']}
              itemToString={item => feeTypeStrings[item]}
              onChange={val => store.setVal('feeType', val)}
            />
          </FilterGroup>
        </CollapsibleFilterGroup>
      </SearchPanelContainer>
    )
  }
}

export default inject('generalFeesStore')(observer(GeneralFeesSearchPanel))
